import ServiceCard from './ServiceCard';
import type { ServiceSummary, ServiceWidget } from '@frontend/types/adminhub';

interface ServicesPanelProps {
  expanded: boolean;
  servicesStatus: 'up' | 'down' | 'unknown';
  serviceWidgets: ServiceWidget[];
  expandedMap: Record<string, boolean>;
  onToggleSection: () => void;
  onToggleWidget: (widgetId: string) => void;
  summarizeService: (serviceId: string) => ServiceSummary;
}

export default function ServicesPanel({
  expanded,
  servicesStatus,
  serviceWidgets,
  expandedMap,
  onToggleSection,
  onToggleWidget,
  summarizeService
}: ServicesPanelProps) {
  return (
    <div className="ecosystem-card admin-widget-card">
      <button type="button" className="admin-widget-header" onClick={onToggleSection}>
        <div className="admin-widget-header-main">
          <h3 className="ecosystem-title">Services</h3>
          <span className={`admin-status-badge status-${servicesStatus}`}>{servicesStatus}</span>
        </div>
        <span className="admin-widget-toggle">{expanded ? '▾' : '▸'}</span>
      </button>

      {expanded ? (
        <div className="admin-widget-body admin-services-body">
          {serviceWidgets.map((service) => (
            <ServiceCard
              key={service.id}
              service={service}
              summary={summarizeService(service.id)}
              expanded={Boolean(expandedMap[service.id])}
              onToggle={() => onToggleWidget(service.id)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
